var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_c('div',{staticClass:"alert-content"},[_c('i',{staticClass:"fas mr-2 fa-bell-exclamation"}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }